import { HttpParams } from '@angular/common/http';
import { Company } from 'app/company/company';

export class CompanyContractFilter {
	company: Company;

	constructor(filter?: CompanyContractFilter) {
		if (filter) {
			this.company = filter.company;
		}
	}

	getHttpParams(httpParams = new HttpParams()): HttpParams {
		if (this.company && this.company.id) {
			httpParams = httpParams.set('companyId', this.company.id.toString());
		}
		return httpParams;
	}
}
